<template>
  <div class="table-basic">
    <b-breadcrumb>
      <b-breadcrumb-item>YOU ARE HERE</b-breadcrumb-item>
      <b-breadcrumb-item>
        <router-link tag="a" to="/app/applications"> Applications</router-link>
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{ formName }}</b-breadcrumb-item>
    </b-breadcrumb>
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" sm="12">
          <b-card header="Project List" header-tag="header">
            <template v-slot:header>
              <div class="text-left" style="display: flex">
                <h3>Project List</h3>
                <!-- <router-link tag="b" to="/app/sfc-list-review-actual-activity" style="position: absolute; right: 15px;">
                  <b-button size="md" type='button' variant="info">
                    <b-icon icon="arrow-left"></b-icon>
                    Back
                  </b-button>
                </router-link> -->
              </div>
            </template>
            <b-row>
              <b-col sm="5">
                <b-form-group
                  label="Sales Person"
                  label-for="SalesPerson"
                  label-cols-sm="3"
                  label-align-sm="left"
                  label-size="sm"
                  class="mb-0"
                >
                  <v-select
                    v-model="sales"
                    :clearable="true"
                    :reduce="(data) => data.sales_nik"
                    :required="true"
                    label="sales_name"
                    placeholder="Choose Sales"
                    :options="options.sales"
                    ref="OptSales"
                  >
                    <template v-slot:option="option">
                      {{ option.sales_nik }} - {{ option.sales_name }}
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      {{ option.sales_nik }} - {{ option.sales_name }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-h="end">
              <b-col lg="3">
                <b-form-group
                  label="Search"
                  label-for="Search-input"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      id="Search-input"
                      v-model="search"
                      type="search"
                      placeholder="Type to Search"
                    ></b-form-input>

                    <b-input-group-append>
                      <b-button :disabled="!search" @click="search = ''"
                        >Clear</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <br />

            <b-table
              :no-border-collapse="true"
              striped
              stacked="md"
              class="header-background max_width_fit"
              hover
              small
              outlined
              :per-page="paging.perPage"
              :current-page="paging.currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              show-empty
              responsive
              sort-icon-left
              :fields="fields"
              @filtered="onFiltered"
              :filter="search"
              :items="FilterItems"
            >
              <!-- table empty -->
              <template #empty="scope">
                <p class="text-center">{{ scope.emptyText }}</p>
              </template>

              <!-- last Activity -->
              <template #cell(last_activity)="row">
                <span v-html="NullTable(row.value)"></span>
              </template>

              <!-- List -->
              <template #cell(printQuo)="row">
                <b-button
                  variant="outline-secondary"
                  @click="btnQuoDet(row.item.project_id, row.item.customer)"
                >
                  <b-icon icon="printer" aria-label="QR"></b-icon>
                </b-button>
              </template>

              <template #cell(printlabel)="row">
                <b-dropdown
                  v-if="
                    row.item.currentphase == 'Finish' ||
                    row.item.currentphase == 'Close' ||
                    row.item.currentphase == 'Ready To Close'
                  "
                  title="QR Options"
                  size="small"
                  pill
                  variant="outline-secondary"
                >
                  <template #button-content>
                    <b-icon
                      v-if="
                        row.item.print_list == 0 || row.item.print_list == null
                      "
                      icon="printer"
                      aria-label="QR"
                    ></b-icon>
                    <b-icon
                      v-if="row.item.print_list > 0"
                      icon="printer-fill"
                      aria-label="QR"
                    ></b-icon>
                  </template>

                  <!-- Dropdown Items -->
                  <div v-for="index in row.item.part_no" :key="index">
                    <b-dropdown-item
                      @click="btnLabel(row.item.project_id, index)"
                      >Part {{ index }}</b-dropdown-item
                    >
                  </div>
                </b-dropdown>
              </template>

              <!-- Print Box -->
              <template #cell(printbox)="row">
                <b-dropdown
                  v-if="
                    row.item.currentphase == 'Finish' ||
                    row.item.currentphase == 'Close' ||
                    row.item.currentphase == 'Ready To Close'
                  "
                  title="QR Options"
                  size="small"
                  pill
                  variant="outline-secondary"
                >
                  <template #button-content>
                    <b-icon
                      v-if="
                        row.item.print_box == 0 || row.item.print_box == null
                      "
                      icon="printer"
                      aria-label="QR"
                    ></b-icon>
                    <b-icon
                      v-if="row.item.print_box > 0"
                      icon="printer-fill"
                      aria-label="QR"
                    ></b-icon>
                  </template>

                  <!-- Dropdown Items -->
                  <div v-for="index in row.item.part_no" :key="index">
                    <b-dropdown-item
                      @click="btnPrintBox(row.item.project_id, index)"
                      >Part {{ index }}</b-dropdown-item
                    >
                  </div>
                </b-dropdown>
              </template>

              <!-- Qr item -->
              <template #cell(qr_box)="row">
                <b-dropdown
                  v-if="
                    row.item.currentphase == 'Finish' ||
                    row.item.currentphase == 'Close' ||
                    row.item.currentphase == 'Ready To Close'
                  "
                  title="QR Options"
                  size="small"
                  pill
                  variant="outline-secondary"
                >
                  <template #button-content>
                    <b-icon
                      v-if="
                        row.item.print_bundle == 0 ||
                        row.item.print_bundle == null
                      "
                      icon="printer"
                      aria-label="QR"
                    ></b-icon>
                    <b-icon
                      v-if="row.item.print_bundle > 0"
                      icon="printer-fill"
                      aria-label="QR"
                    ></b-icon>
                  </template>

                  <!-- Dropdown Items -->
                  <div v-for="index in row.item.part_no" :key="index">
                    <b-dropdown-item
                      @click="btnQrItem(row.item.project_id, index)"
                      >Part {{ index }}</b-dropdown-item
                    >
                  </div>
                </b-dropdown>
              </template>

              <template #cell(action)="row">
                <b-button
                  title="View"
                  size="xs"
                  variant="outline-info"
                  v-on:click="
                    viewData(row.item.project_id, row.item.customer_name)
                  "
                  style="margin-right: 5px"
                >
                  <b-icon icon="eye-fill" aria-label="View"></b-icon>
                </b-button>
                <b-button
                  v-if="row.item.currentphase == 'Ready To Close'"
                  title="Closing"
                  size="xs"
                  variant="outline-primary"
                  v-on:click="closeData(row)"
                >
                  <b-icon
                    icon="file-earmark-check-fill"
                    aria-label="Closing"
                  ></b-icon>
                </b-button>
                <b-button
                  v-if="
                    row.item.currentphase == 'Initial' ||
                    row.item.currentphase == 'Progress'
                  "
                  title="Abort"
                  size="xs"
                  variant="outline-danger"
                  v-on:click="abortData(row)"
                >
                  <b-icon icon="trash-fill" aria-label="Abort"></b-icon>
                </b-button>
                <b-dropdown
                  v-if="
                    row.item.currentphase != 'Initial' &&
                    row.item.currentphase != 'Progress'
                  "
                  title="View Article"
                  size="xs"
                  variant="outline-secondary"
                >
                  <template #button-content>
                    <b-icon icon="list-task" aria-label="Article"></b-icon>
                  </template>
                  <div v-for="index in row.item.part_no" :key="index">
                    <b-dropdown-item @click="viewArticle(row, index)"
                      >Part {{ index }}</b-dropdown-item
                    >
                  </div>
                </b-dropdown>
              </template>
            </b-table>
            <b-row>
              <b-col sm="4">
                Showing {{ showPerPage }} of {{ totalData }} entries
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label="Per Page"
                  label-for="PerPage"
                  label-cols-sm="6"
                  label-align-sm="right"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-form-input
                    style="max-width: 80px"
                    id="PerPage"
                    v-model="paging.perPage"
                    @input="Pagging()"
                    type="number"
                    max="999"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4" align-self="end" class="my-1">
                <b-pagination
                  v-model="paging.currentPage"
                  :total-rows="rows"
                  :per-page="paging.perPage"
                  align="right"
                  size="sm"
                >
                  <template #first-text><span class="">First</span></template>
                  <template #prev-text><span class="">Prev</span></template>
                  <template #next-text><span class="">Next</span></template>
                  <template #last-text><span class="">Last</span></template>
                  <template #page="{ page, active }">
                    <b v-if="active">{{ Pagination(page) }} {{ page }}</b>
                    <i v-else>{{ page }}</i>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-modal
        header-bg-variant="secondary"
        hide-footer
        hide-backdrop
        size="md"
        title="Article List"
        v-model="modalArticle"
      >
        <b-row>
          <b-col cols="6" v-for="(row, index) in dataUkurArticle" :key="index">
            <ul
              style="
                list-style-type: disc;
                list-style-position: inside;
                margin-left: 10px;
              "
              class="my-2"
            >
              <li>{{ row }}</li>
            </ul>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal
        ok-variant="success"
        cancel-variant="warning"
        header-bg-variant="secondary"
        hide-footer
        hide-header-close
        hide-backdrop
        size="md"
        no-close-on-backdrop
        title="Status Reason"
        v-model="reasonAbort"
      >
        <form>
          <b-form-group label="Reason" label-for="PO ID">
            <b-form-input
              id="Reason"
              v-model="status_reason"
              required
            ></b-form-input>
          </b-form-group>
          <b-row align-h="end">
            <b-col sm="3">
              <b-button
                block
                size="md"
                type="button"
                variant="success"
                @click="saveReason()"
              >
                Submit
              </b-button>
            </b-col>
            <b-col sm="3">
              <b-button
                block
                size="md"
                @click="cancelAbort()"
                type="button"
                variant="warning"
              >
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </form>
      </b-modal>
      <Loader
        v-if="isLoadingData"
        fullPage
        useOverlay
        loader="spinner"
      ></Loader>
    </b-container>
    <PrintBox />
    <PrintLabel />
    <PrintQr />
    <PrintQuo />

    <b-modal
      v-model="showModal"
      ok-variant="success"
      cancel-variant="warning"
      header-bg-variant="secondary"
      hide-footer
      hide-header-close
      hide-backdrop
      size="lg"
      no-close-on-backdrop
      title="Detail"
    >
      <div id="modal">
        <b-row>
          <b-col cols="12" style="position: relative">
            <b-icon
              @click="addData()"
              style="cursor: pointer; position: absolute; right: 20px"
              font-scale="1.5"
              variant="success"
              icon="file-plus"
            ></b-icon>
          </b-col>
        </b-row>
        <br />
        <br />
        <b-row v-for="(data, index) in detailQuo" :key="index">
          <b-col cols="1">
            <b-icon
              @click="deleteData(index)"
              style="cursor: pointer; top: 6px; position: absolute; right: 0px"
              font-scale="1.5"
              variant="danger"
              icon="trash"
            ></b-icon>
          </b-col>
          <b-col cols="11">
            <b-form-group>
              <b-form-input
                :value="data.value"
                style="color: #333 !important"
                @input="changeInput(index, $event)"
                placeholder="Input Keterangan"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="end">
          <b-col sm="3">
            <b-button
              block
              v-if="generate"
              size="md"
              type="button"
              variant="dark"
              @click="generatePdf()"
            >
              Generate PDF
            </b-button>
          </b-col>
          <b-col sm="3">
            <b-button
              block
              size="md"
              @click="saveDetail()"
              type="button"
              variant="success"
            >
              Save
            </b-button>
          </b-col>
          <b-col sm="3">
            <b-button
              block
              size="md"
              @click="cancelDetail()"
              type="button"
              variant="warning"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loader from "@/components/Loader/Loader";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import Vue from "vue";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_SALESFORCE } from "../../../../api/api-paths";
import PrintBox from "./printBoxList.vue";
import PrintLabel from "./printLabelList.vue";
import PrintQr from "./printQrItem.vue";
import PrintQuo from "./printQuoItem.vue";
import { EventBus } from "./eventBus";

export default {
  components: {
    ModelListSelect,
    Loader,
    PrintBox,
    PrintLabel,
    PrintQr,
    PrintQuo,
  },
  data() {
    const now = new Date();
    const today = now.toISOString().slice(0, 10);
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const optyear = { year: "numeric" };
    const year = now.toLocaleString("en-US", optyear);
    const optmonth = { month: "numeric" };
    const SMonth = { month: "short" };
    const month = now.toLocaleString("en-US", optmonth);
    const Strmonth = now.toLocaleString("en-US", SMonth);
    const optdays = { day: "numeric" };
    const days = now.toLocaleString("en-US", optdays);
    return {
      isLoadingData: false,
      formName: "Project List",
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      today: today,
      isChecked: false,
      disabledForm: false,
      buttonSubmit: null,
      today_days: days,
      today_month: month,
      reasonAbort: false,
      modalArticle: false,
      StrMonth: Strmonth,
      previousSelected: [],
      today_year: year,
      fields: [
        {
          key: "action",
          label: "Action",
          sortable: false,
        },
        {
          key: "project_id",
          label: "Project ID",
          sortable: true,
          class: "min-9vw",
        },
        {
          key: "po_id",
          label: "No Po",
          sortable: true,
        },
        {
          key: "sales_nik",
          label: "sales nik",
          sortable: true,
        },
        {
          key: "sales_name",
          label: "Sales",
          sortable: false,
        },
        { key: "customer", class: "display-hidden" },
        {
          key: "customer_name",
          label: "Customer",
          sortable: true,
        },
        {
          key: "currentphase",
          label: "Status",
          sortable: true,
        },
        {
          key: "last_activity",
          label: "activity",
          sortable: false,
        },
        {
          key: "printQuo",
          label: "Quotation",
          tdClass: "align_center_table",
          sortable: false,
        },
        {
          key: "printlabel",
          label: "picking list",
          tdClass: "align_center_table",
          sortable: false,
        },
        {
          key: "printbox",
          label: "sticker box",
          sortable: false,
          class: "min-9vw",
          tdClass: "align_center_table",
        },
        {
          key: "qr_box",
          label: "sticker bundle",
          class: "min-10vw",
          tdClass: "align_center_table",
          sortable: false,
        },
        // {
        //   key: "status_tender",
        //   label: "status tender",
        //   sortable: false,
        // },
        // {key:'sub_activity_name', label:'Sub Activity', class:"min-10vw", sortable:false },
        // {key:'reason', label:'Reason', class:"min-10vw", sortable:false },
      ],
      dataTable: [],
      dataUkurArticle: [],
      sortBy: "",
      sortDesc: false,
      showPerPage: 0,
      totalData: 0,
      PageNow: 1,
      paging: {
        perPage: 10,
        currentPage: 1,
      },
      form: {
        employee_nik: null,
        employee_name: null,
        end_date: null,
        start_date: null,
      },
      options: {
        sales: [],
        customer: [],
      },
      search: null,
      sales: null,
      status_reason: null,
      rowData: null,
      projectID: null,
      customer: null,
      showModal: false,
      generate: false,
      detailQuo: [],
    };
  },

  computed: {
    ...mapGetters("session", ["userData"]),
    rows() {
      if (this.totalData != null) {
        return this.totalData;
      }
    },
    FilterItems() {
      let sales_nik = this.sales;
      return this.dataTable.filter(function (item) {
        let filtereds = true;
        if (sales_nik && sales_nik.length > 0) {
          filtereds = item.sales_nik == sales_nik;
        }
        return filtereds;
      });
    },
  },
  methods: {
    ...mapActions("session", ["showNotification"]),

    btnPrintBox(val, index) {
      const param = val;
      const paramindex = index;
      EventBus.$emit("open-printbox", param, paramindex);
    },
    generatePdf() {
      const param = this.projectID;
      const paramindex = 0;
      EventBus.$emit("open-printquo", param, paramindex);
    },
    saveDetail() {
      this.isLoadingData= true
      fnPOST(APIPATH_SALESFORCE.postQuotation, {
        project_id: this.projectID,
        customer_id: this.customer,
        detail: this.detailQuo,
        created_by:this.form.employee_nik,
        created_by_name:this.form.employee_name,
      }).then((rsp) => {
        this.isLoadingData= false
        this.generate = true
        this.showNotification({
          type: "success",
          message: "Successfully Submitted",
        });
      }).catch(err => {
        this.isLoadingData= false
        this.showNotification({
          type: "error",
          message: err,
        });
      })
    },
    changeInput(index, event) {
      console.log(index);
      console.log(event);
      this.detailQuo[index].value = event;
    },
    deleteData(index) {
      this.detailQuo.splice(index, 1);
    },
    addData() {
      this.detailQuo.push({
        value: null,
      });
    },
    cancelDetail() {
      this.generate = false;
      this.projectID = null;
      this.customer = null;
      this.showModal = false;
      this.detailQuo = null;
    },
    btnQuoDet(val, id) {
      this.isLoadingData = true;
      console.log(val);
      console.log(id);
      this.projectID = val;
      this.customer = id;
      fnPOST(APIPATH_SALESFORCE.getQuotationDet, {
        project_id: this.projectID,
      })
        .then((rsp) => {
          let data = rsp.data.payload;
          if (data.length > 0) {
            this.detailQuo = data;
            this.showModal = true;
            this.generate = true;
            this.isLoadingData = false;
          } else {
            this.generate = false;
            this.loadDetParam();
          }
        })
        .catch((err) => {
          this.isLoadingData = false;
        });
    },

    loadDetParam() {
      fnPOST(APIPATH_SALESFORCE.getParamQuotation, {
        category: "quotation",
      })
        .then((rsp) => {
          this.isLoadingData = false;
          let data = rsp.data.payload;
          if (data.length > 0) {
            this.detailQuo = data;
            this.showModal = true;
          }
        })
        .catch((err) => {
          this.isLoadingData = false;
        });
    },
    btnLabel(val, index) {
      const param = val;
      const paramindex = index;
      EventBus.$emit("open-printlabel", param, paramindex);
    },
    btnQrItem(val, index) {
      const param = val;
      const paramindex = index;
      EventBus.$emit("open-qritem", param, paramindex);
    },
    setData() {
      this.form.employee_nik = this.userData.nik;
      this.form.employee_name = this.userData.fullname;
      let statusRoute = this.$route.params.data;
      let idData = this.$route.params.idData;
      if (statusRoute == undefined || statusRoute == "") {
        statusRoute = null;
      }
      this.LoadData();
      this.getSalesPerson();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalData = filteredItems.length;
      this.paging.currentPage = 1;
      this.showPerPage = filteredItems.length;
      if (filteredItems.length >= this.paging.perPage) {
        this.showPerPage = this.paging.perPage;
      }
    },
    Pagging() {
      if (this.showPerPage > this.paging.perPage) {
        this.showPerPage = this.paging.perPage;
      }
      if (this.showPerPage < this.paging.perPage) {
        this.showPerPage = this.paging.perPage;
      }
      if (this.showPerPage >= this.totalData) {
        this.showPerPage = this.totalData;
      }
    },
    Pagination(value) {
      if (value !== this.PageNow) {
        if (value > this.PageNow) {
          this.PageNow = value;
          // this.nextPage()
          this.showPerPage = this.paging.perPage * this.PageNow;
          if (this.showPerPage >= this.totalData) {
            this.showPerPage = this.totalData;
          }
        } else {
          this.PageNow = value;
          this.showPerPage =
            this.showPerPage -
            (this.showPerPage - this.paging.perPage * this.PageNow);
          if (this.showPerPage <= this.paging.perPage) {
            this.showPerPage = this.paging.perPage;
          }
        }
      }
    },
    getSalesPerson() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getSalesPerson, {})
        .then((rsp) => {
          this.options.sales = rsp.data.payload;
        })
        .catch((err) => {
          if (err.response.status !== 401) {
            this.showNotification({
              type: "error",
              message: "Failed, Please Try Again",
            });
          }
        })
        .finally(() => {
          // stop loading
          setTimeout(() => {
            this.isLoadingData = false;
          }, 500);
        });
    },
    LoadData() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getListProject, {})
        .then((rsp) => {
          if (rsp.data.payload == null || rsp.data.payload == undefined) {
            this.dataTable = [];
            this.totalData = 0;
          } else {
            this.dataTable = rsp.data.payload;
            this.totalData = rsp.data.payload.length;
          }
          this.showPerPage = this.paging.perPage;
          if (this.totalData < this.paging.perPage) {
            this.showPerPage = this.totalData;
          }
        })
        .catch((err) => {
          if (err.response.status !== 401) {
            this.showNotification({
              type: "error",
              message: "Gagal Load Data, Silahkan Coba Kembali",
            });
          }
        })
        .finally(() => {
          // stop loading
          setTimeout(() => {
            this.isLoadingData = false;
          }, 500);
        });
    },
    FormatDate(value) {
      if (value == null || value == undefined || value == "") {
        return " ";
      } else {
        let date = new Date(value);
        let nameDay = this.dayNames[date.getDay()];
        let day = date.getDate();
        if (String(day).length == 1) {
          day = "0" + String(day);
        }
        let year = date.getFullYear();
        let bulan = this.monthNames[date.getMonth()];
        date = nameDay + " " + day + " " + bulan + " " + year;
        return date;
      }
    },
    NullTable(value) {
      let result = value;
      if (value == null || value == undefined || value == "") {
        result = "-";
      }
      if (value !== null) {
        result = value.replace(/[^a-zA-Z0-9,()/& ]/g, "");
      }
      return result;
    },
    viewData(data, customer) {
      this.$router.push({
        name: "SFCListActualProject",
        params: { customer: customer, idData: data },
      });
    },
    viewArticle(data, index) {
      this.dataUkurArticle = [];
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getOrderBox, {
        project_id: data.item.project_id,
        part_no: index,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          let data = rsp.data.payload;
          if (rsp) {
            if (data.length > 0) {
              data.forEach((val) => {
                if (!this.dataUkurArticle.includes(val.article)) {
                  this.dataUkurArticle.push(val.article);
                }
              });
            }
          }
          this.modalArticle = true;
        })
        .catch((err) => {
          this.showNotification({
            type: "error",
            message: err.response.data.message,
          });
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    },
    closeData(row) {
      let varOk = "warning";
      let Boxtrue = "";
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to close this project ?", {
          title: "Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: varOk,
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          Boxtrue = value;
          if (Boxtrue == true) {
            this.processClose(row);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    abortData(row) {
      this.reasonAbort = true;
      this.rowData = row;
    },
    cancelAbort() {
      this.reasonAbort = false;
      this.rowData = null;
      this.status_reason = null;
    },
    saveReason() {
      if (
        this.status_reason == null ||
        this.status_reason == "" ||
        this.status_reason == " "
      ) {
        alert("reason harus diisi");
        return false;
      }
      let projectID = this.rowData.item.project_id;
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.abortProject, {
        project_id: projectID,
        status_reason: this.status_reason,
        user_nik: this.form.employee_nik,
        user_name: this.form.employee_name,
      })
        .then((rsp) => {
          this.showNotification({
            type: "success",
            message: "Successfully Submitted",
          });
          this.LoadData();
          this.cancelAbort();
        })
        .catch((err) => {
          if (err.response.status !== 401) {
            this.showNotification({
              type: "error",
              message: "Failed, Please Try Again",
            });
          }
        })
        .finally(() => {
          // stop loading
          setTimeout(() => {
            this.isLoadingData = false;
          }, 500);
        });
    },
    processClose(row) {
      let projectID = row.item.project_id;
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.closeProject, {
        project_id: projectID,
        user_nik: this.form.employee_nik,
        user_name: this.form.employee_name,
      })
        .then((rsp) => {
          this.showNotification({
            type: "success",
            message: "Successfully Submitted",
          });
          this.LoadData();
        })
        .catch((err) => {
          if (err.response.status !== 401) {
            this.showNotification({
              type: "error",
              message: "Failed, Please Try Again",
            });
          }
        })
        .finally(() => {
          // stop loading
          setTimeout(() => {
            this.isLoadingData = false;
          }, 500);
        });
    },
  },
  created() {
    try {
      this.search = this.$route.query.search;
    } catch (error) {
      this.search = null;
    }
    this.setData();
  },
};
</script>
<style>
.align_center_table {
  text-align: center !important;
  padding-left: 0px !important;
}
.align_left_table {
  text-align: start !important;
  padding-left: 10px !important;
}
</style>
<style src="../SalesForce.scss" lang="scss" scoped />
